/**
 * UrbanismeNav — barre d'onglets du back-office Urbanisme (staff).
 * Jumeau de GrcNav, accent « urba ».
 */

import { useNavigate } from 'react-router-dom';
import { type ReactNode } from 'react';

export type UrbanismeNavKey = 'dossiers' | 'instruire' | 'decides' | 'documents' | 'presence';

function Tab({ active, onClick, children }: { active: boolean; onClick: () => void; children: ReactNode }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={[
        'h-8 inline-flex items-center gap-1.5 rounded-r-pill px-3.5 text-xs font-medium transition-colors',
        active
          ? 'bg-urba-tint/80 text-urba-fg border border-urba/30'
          : 'text-ink-muted border border-transparent hover:text-ink',
      ].join(' ')}
    >
      {children}
    </button>
  );
}

export function UrbanismeNav({ active }: { active: UrbanismeNavKey }) {
  const navigate = useNavigate();
  return (
    <div className="flex flex-wrap items-center gap-2">
      <Tab active={active === 'dossiers'} onClick={() => navigate('/urbanisme')}>Dossiers</Tab>
      <Tab active={active === 'instruire'} onClick={() => navigate('/urbanisme/instruire')}>À instruire</Tab>
      <Tab active={active === 'decides'} onClick={() => navigate('/urbanisme/decides')}>Décidés</Tab>
      <Tab active={active === "presence"} onClick={() => navigate("/urbanisme/presence")}>Planning</Tab>
      <Tab active={active === 'documents'} onClick={() => navigate('/urbanisme/documents')}>Documents</Tab>
    </div>
  );
}
